module.exports = __webpack_public_path__ + "img/wxjs.394bc0e0.png";